// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-audit-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.sa-audit-item {
    background: var(--sa-card);
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    gap: 18px;
    align-items: center;
    border-left: 4px solid transparent;
}

.sa-audit-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/SuperAdmin/SAAuditLog.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB","sourcesContent":[".sa-audit-container {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.sa-audit-item {\n    background: var(--sa-card);\n    border-radius: 12px;\n    padding: 16px 20px;\n    display: flex;\n    gap: 18px;\n    align-items: center;\n    border-left: 4px solid transparent;\n}\n\n.sa-audit-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
